import { useLocation } from 'react-router-dom'

export default function useTabPath(tabOptions: string[]) {
    const { pathname } = useLocation()
    const path = pathname.split('/').pop()

    const matchedTab = tabOptions.find((tabOption) => path === tabOption)
    return matchedTab
}
